// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_c77b407","title":"_0349ecd","amount":"_e578f08","won":"_78c32f9","extraWallet":"_dbfcdea"};